'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DyzioModalHeader = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _dyzioButtons = require('../dyzio-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerStyles = {
  textCenter: {
    textAlign: 'center'
  },
  description: {
    fontSize: 13,
    fontWeight: 'normal',
    color: 'gray'
  }
};

var closeModalIconStyle = {
  float: 'right',
  cursor: 'pointer'
};

var noMarginStyle = {
  margin: 0
};

var textCenteredStyle = {
  textAlign: 'center'
};

var DyzioModalHeader = exports.DyzioModalHeader = function DyzioModalHeader(_ref) {
  var headerText = _ref.headerText,
      onClose = _ref.onClose;
  return _react2.default.createElement(
    _semanticUiReact.Modal.Header,
    { style: headerStyles.textCenter },
    headerText,
    _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'delete',
      position: 'right',
      style: closeModalIconStyle,
      onClick: onClose
    })
  );
};

var DyzioModal = function DyzioModal(props) {
  var size = props.size,
      mountNode = props.mountNode,
      style = props.style,
      onClose = props.onClose,
      headerText = props.headerText,
      headerDescription = props.headerDescription,
      children = props.children,
      hasActionButton = props.hasActionButton,
      actionButtonColor = props.actionButtonColor,
      hasCloseButton = props.hasCloseButton,
      actionButtonContent = props.actionButtonContent,
      actionButtonIcon = props.actionButtonIcon,
      onActionButtonClick = props.onActionButtonClick,
      hasFeedbackProvider = props.hasFeedbackProvider,
      feedbackContent = props.feedbackContent,
      feedbackIcon = props.feedbackIcon,
      feedbackType = props.feedbackType,
      shouldDisableActionButton = props.shouldDisableActionButton,
      onOpen = props.onOpen;


  var withActions = hasActionButton || hasCloseButton;
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      size: size,
      open: true,
      mountNode: mountNode,
      style: style,
      onClose: onClose,
      onOpen: onOpen,
      closeOnEscape: true,
      closeOnDimmerClick: true
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      { style: headerStyles.textCenter },
      headerText,
      _react2.default.createElement(_semanticUiReact.Icon, {
        name: 'delete',
        position: 'right',
        style: closeModalIconStyle,
        onClick: onClose
      }),
      headerDescription && _react2.default.createElement(
        _semanticUiReact.Modal.Description,
        { style: headerStyles.description },
        headerDescription
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      children,
      hasFeedbackProvider && _react2.default.createElement(
        _semanticUiReact.Modal.Content,
        { extra: true },
        _react2.default.createElement(_semanticUiReact.Divider, { fitted: true }),
        _react2.default.createElement(
          _semanticUiReact.Message,
          {
            info: feedbackType === 'info',
            warning: feedbackType === 'warning',
            error: feedbackType === 'error'
          },
          feedbackIcon && _react2.default.createElement(_semanticUiReact.Icon, { name: feedbackIcon }),
          feedbackContent
        )
      )
    ),
    withActions && _react2.default.createElement(
      _semanticUiReact.Modal.Actions,
      { style: hasCloseButton ? textCenteredStyle : null },
      hasActionButton && _react2.default.createElement(_dyzioButtons.DyzioModalActionButton, {
        label: actionButtonContent,
        onClick: onActionButtonClick,
        style: noMarginStyle,
        fluid: !hasCloseButton,
        color: actionButtonColor,
        hasIcon: true,
        icon: actionButtonIcon,
        disabled: shouldDisableActionButton
      }),
      hasCloseButton && _react2.default.createElement(_dyzioButtons.DyzioCancelButton, {
        label: _react2.default.createElement(
          'span',
          null,
          'Close'
        ),
        onClick: onClose,
        color: 'grey',
        floated: null,
        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
        hasIcon: true
      })
    )
  );
};

DyzioModal.propTypes = {
  children: _propTypes2.default.node.isRequired,
  headerText: _propTypes2.default.string.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  hasActionButton: _propTypes2.default.bool,
  hasFeedbackProvider: _propTypes2.default.bool,
  shouldDisableActionButton: _propTypes2.default.bool,
  mountNode: _propTypes2.default.object,
  style: _propTypes2.default.object,
  size: _propTypes2.default.string,
  actionButtonColor: _propTypes2.default.string,
  actionButtonIcon: _propTypes2.default.any,
  actionButtonContent: _propTypes2.default.any
};

DyzioModal.defaultProps = {
  mountNode: typeof document !== 'undefined' && document.body,
  style: {},
  hasFeedbackProvider: false,
  hasActionButton: false,
  shouldDisableActionButton: false,
  size: 'large',
  actionButtonColor: 'pink'
};

exports.default = DyzioModal;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-modal/index.js
 ** module id = 32
 ** module chunks = 0
 **/